const topics = [
  {
    title: "Order of Operations",
    slug: "orderofoperations",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Expressions",
    slug: "expressions",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Numerical Expression",
    slug: "numericalexpression",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Commutative Properties of Multiplication",
    slug: "commutativepropertiesofmultiplication",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Commutative Properties of Addition",
    slug: "commutativepropertiesofaddition",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Associative Properties of Multiplication",
    slug: "associativepropertiesofmultiplication",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Associative Properties of Addition",
    slug: "associativepropertiesofaddition",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Distributive Property",
    slug: "distributiveproperty",
    standardNumber: "NC.5.OA.2",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Pattern Maker",
    slug: "patternmaker",
    standardNumber: "NC.5.OA.3",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Place Value",
    slug: "placevalue",
    standardNumber: "NC.5.NBT.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Ten Times More",
    slug: "tentimesmore",
    standardNumber: "NC.5.NBT.1",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Compare Decimals",
    slug: "comparedecimals",
    standardNumber: "NC.5.NBT.3",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Stack and Multiply",
    slug: "stackandmultiply",
    standardNumber: "NC.5.NBT.5",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Multiply Decimals",
    slug: "multiplydecimals",
    standardNumber: "NC.5.NBT.7",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Dividing Decimals",
    slug: "dividingdecimals",
    standardNumber: "NC.5.NBT.7",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Add & Subtract Fractions",
    slug: "addsubtractfractions",
    standardNumber: "NC.5.NF.1",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Dividing Fractions",
    slug: "dividingfractions",
    standardNumber: "NC.5.NF.3",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Multiply Fractions",
    slug: "multiplyfractions",
    standardNumber: "NC.5.NF.4",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Division & Fractions",
    slug: "divisionfractions",
    standardNumber: "NC.5.NF.7",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  }
];
export default topics;